export const homePageData = {
  links: {
    premiumCTALink: (ref_medium) =>
      `/premium/pricing/?ref_source=sitepoint&unlock=true&ref_medium=${ref_medium}`,
    browseLibrary: `/premium/library/`,
  },
}
